import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { GlobalMessages } from '../../types/Messages';
import { languageUtils } from '../../utils/languageUtils/languageUtils';

export const hooks = {
  useRedirectWithDefaultLanguage() {
    const history = useHistory();
    const { pathname, search } = useLocation();
    const defaultLanguage = languageUtils.getDefaultLanguage();
    const isStartsWithDefaultLanguage = pathname.startsWith(
      `/${defaultLanguage}/`,
    );
    React.useEffect(() => {
      if (isStartsWithDefaultLanguage) {
        history.push({
          pathname: pathname.replace(`/${defaultLanguage}/`, '/'),
          search,
        });
      }
    }, [defaultLanguage, history, isStartsWithDefaultLanguage, pathname, search]);
  },
  useLanguageChangeDetection() {
    const setLanguage = messageHooks.useNext(GlobalMessages.Language);
    const { pathname } = useLocation();
    const isStartsWithDefaultLanguage = pathname.startsWith(
      `/${languageUtils.getDefaultLanguage()}/`,
    );

    React.useEffect(() => {
      const langRegExp = languageUtils.getLanguageRegularExpression();

      const match = pathname.match(langRegExp);
      if (match) {
        const language = match[0].replaceAll('/', '');
        setLanguage(isStartsWithDefaultLanguage ? '' : language);
      }
    }, [isStartsWithDefaultLanguage, pathname, setLanguage]);
  },
};

export const LocaleDetectContainer = () => {
  hooks.useRedirectWithDefaultLanguage();
  hooks.useLanguageChangeDetection();
  return null;
};

LocaleDetectContainer.displayName = 'LocaleDetectContainer';
